import type { PushDevice } from '@nexus/core';
import { queryOptions } from '@tanstack/react-query';
import { api } from '../api/client';

/** The channels the company offers the person, and the devices with push (ADR-0020, ADR-0058). */
export interface PersonalChannels {
  email: { available: boolean; address: string | null };
  teams: { available: boolean };
  push: {
    available: boolean;
    /** VAPID key of the platform, `null` while the company does not offer push. */
    publicKey: string | null;
    devices: { id: string; device: PushDevice; endpoint: string; createdAt: string }[];
  };
}

export const personalChannelsQuery = queryOptions({
  queryKey: ['notification-channels'],
  queryFn: ({ signal }) => api.get<PersonalChannels>('/notifications/channels', { signal }),
});
